import { render, staticRenderFns } from "./AccordionContainer.vue?vue&type=template&id=1077c614&scoped=true"
import script from "./AccordionContainer.vue?vue&type=script&lang=js"
export * from "./AccordionContainer.vue?vue&type=script&lang=js"
import style0 from "./AccordionContainer.vue?vue&type=style&index=0&id=1077c614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077c614",
  null
  
)

export default component.exports